module.exports = __webpack_public_path__ + "static/media/hng-logo.485222f4.png";